import { Action } from 'redux';

import { isHideRouterErrorAction, isShowRouterErrorAction } from '../actions/spaces/RouterErrorActions';
import { ReduxRouterErrorState } from '../state/ReduxRouterErrorState';

const InitialState: ReduxRouterErrorState = {
  displayError: false,
  errorType: 'default',
  redirectSiteUrlName: ''
};

export function routerErrorReducer(
  previousState: ReduxRouterErrorState = InitialState,
  action: Action = null
): ReduxRouterErrorState {

  if (isShowRouterErrorAction(action)) {
    return {
      displayError: true,
      errorType: action.errorType,
      redirectSiteUrlName: action.redirectSiteUrlName
    };
  }

  if (isHideRouterErrorAction(action)) {
    return InitialState;
  }

  return previousState;
}
